export default {
  Discard: -1,
  Created: 0,
  Confirming: 1,
  Running: 2,
  RenewalInviting: 3,
  RenewalConfirming: 4,
  RenewalRefused: 5,
  Ending: 9,
}
